import { useSelector, useDispatch } from "react-redux";
import { useLoader } from "@/hooks/LoaderProvider";
import { useNavigate } from "react-router-dom";
import Button from "@/components/common/Button";
import Copyright from "@/components/layout/Footer/Copyright";
import { getFirstName } from "@/utils/nameUtils";
import { setAuthenticated } from "@/store/redux/slices/auth/auth_slice";
import { resetOrganization } from "@/store/redux/slices/kyc/kyc_setup_slice";
import { resetFiles } from "@/store/redux/slices/user/file_upload_slice";
import { selectUserInfo } from "@/store/redux/slices/auth/auth_slice";
import logo from "@/assets/icons/web_Icons/veegil_logo.svg";
import SuccessGif from "@/assets/images/veegil_loader/Success.gif";
import Avatar from "@/components/common/Avatar";

const AccountSetupSuccess = () => {
  const { showLoader, hideLoader } = useLoader();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // Get user info from auth slice
  const userInfo = useSelector(selectUserInfo);
  const userFirstName = getFirstName(userInfo?.fullname);

  const handleContinueToDashboard = () => {
    // Clear all setup data
    dispatch(resetOrganization());
    dispatch(resetFiles());

    // Set authenticated and navigate
    dispatch(setAuthenticated(true));
    navigate("/dashboard");
  };

  const handleSetUpSubscriptionPlan = () => {
    showLoader();
    try {
      // Clear all setup data
      dispatch(resetOrganization());
      dispatch(resetFiles());

      // Navigate to subscription page
      navigate("/subscription");
    } catch (error) {
      console.error("Error navigating to subscription:", error);
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      {/* Top section */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center logo-container">
          <img
            src={logo}
            alt="Veegil Logo"
            className="logo-image w-[53px] h-[44px]"
          />
          <span className="text-[24px] text-primary font-roboto-slab font-normal">
            Veegil
          </span>
        </div>
        <div className="flex items-center">
          <Avatar
            size={32}
            src={userInfo?.profileImage}
            className="mr-2"
            alt={userFirstName || "User"}
          />
          <span className="text-bold text-primary">
            Hello, {userFirstName || "User"}
          </span>
        </div>
      </div>

      {/* Middle section */}
      <div className="flex flex-col items-center w-full px-4 mt-4 mb-8 mx-auto max-w-[600px]">
        <div className="flex justify-center mb-6">
          <img
            src={SuccessGif}
            alt="Success Icon"
            style={{
              width: "200px",
              height: "200px",
              margin: "0 auto",
              display: "block",
            }}
          />
        </div>

        <h1 className="mb-2 text-center heading-large text-primary">
          KYC SUBMITTED
        </h1>
        <p className="mb-6 text-center text-small text-darkGrey">
          Our team will go through your information and revert back to you in
          the next couple of business days.
        </p>

        <div className="flex flex-col w-full gap-4">
          <Button
            text="Continue to Dashboard"
            onClick={handleContinueToDashboard}
            customBgColor="primary"
            customTextColor="white"
            className="w-full py-3"
          />
          <Button
            text="Set Up Subscription Plan"
            onClick={handleSetUpSubscriptionPlan}
            customBgColor="primary"
            customTextColor="white"
            className="w-full py-3"
          />
        </div>
      </div>

      <div className="mt-auto">
        <Copyright />
      </div>
    </div>
  );
};

export default AccountSetupSuccess;
